import apiClient from '../apiClient';

const baseUrl = '/ai/ds/simple';

export type DsItem = {
  _id?: string;
  messages: any[];
};

/** 分页列表 */
export async function queryUserList(params: {
  current?: number;
  pageSize?: number;
  username?: string;
  roleCode?: string;
}) {
  return apiClient<{
    list: DsItem[];
    total: number;
  }>(baseUrl, {
    method: 'GET',
    params,
  });
}

/** 使用deepseek */
export async function getDsData(data: DsItem) {
  return apiClient<{ code: number; data: { message: { content: string } }[] }>(
    baseUrl,
    {
      method: 'POST',
      data,
    },
  );
}
